import React, { useState } from "react";
import styles from "./Services.module.css";

const servicesData = [
  {
    image: "/images/service1.jpg",
    title: "DINE ON DEMAND",
    description:
      "Enjoy a personalized dining experience with our Dine on Demand service. Whether you prefer breakfast in bed, a late-night snack, or a curated gourmet meal, our chefs are ready to prepare dishes to your liking, anytime you need it.",
  },
  {
    image: "/images/service2.jpg",
    title: "CONFERENCE ROOM",
    description:
      "For business travelers, our conference room and business center offer a professional environment equipped with different services, and video conferencing facilities. Whether you need to host a meeting or work remotely, we've got you..",
  },
  {
    image: "/images/service3.jpg",
    title: "WORKOUT FACILITIES",
    description:
      "Stay active during your stay with access to our fully equipped fitness center. Featuring modern workout machines, free weights, and personal training options, our gym ensures you can maintain your fitness routine with ease.",
  },
  {
    image: "/images/service4.jpg",
    title: "AURELIA  CHAUFFEUR SERVICE ",
    description:
      "Enjoy secure, stylish travel with Aurelia’s chauffeur service. From airport transfers to full-day bookings, our professional drivers deliver a seamless and luxurious experience every time.",
  },
];

const Services = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <section className={styles.section}>
      <div className={styles.textWrapper}>
        <div className={styles.textLeft}>
          <p className={styles.intro}>Elevate your stay with</p>
          <h2 className={styles.heading}>Our Premium Services</h2>
        </div>

        <div className={styles.textRight}>
          <p className={styles.description}>
            True luxury is not just about opulence, but about an experience that
            lingers long after. Beyond aesthetics, beyond comfort, Aurelia
            redefines luxury as an immersive world of grace, beauty, and
            distinction.
          </p>
        </div>
      </div>

      <div className={styles.cards}>
        {servicesData.map((service, index) => {
          const isHovered = hoveredIndex === index;
          const isOtherHovered = hoveredIndex !== null && !isHovered;

          return (
            <div
              key={index}
              className={styles.card}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              style={{
                flex: isHovered ? 5 : isOtherHovered ? 2.5 : 1,
              }}
            >
              <img
                src={service.image}
                alt={service.title}
                className={`${styles.image} ${
                  isHovered ? styles.hovered : styles.notHovered
                }`}
              />
              <div
                className={styles.cardContent}
                style={{ opacity: isOtherHovered ? 0 : 1 }}
              >
                <h3 className={styles.cardTitle}>{service.title}</h3>
                <p className={styles.cardDescription}>{service.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Services;
